export default __webpack_public_path__ + "static/media/Visa.86f743e2.svg";